var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconHourglass = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 23C4.44772 23 4 22.5523 4 22C4 21.4872 4.38604 21.0645 4.88338 21.0067L5 21H5.999L6 18C6 15.6025 7.39671 13.2744 9.1873 11.9996C7.39671 10.7256 6 8.39746 6 6L5.999 3H5C4.44772 3 4 2.55228 4 2C4 1.48716 4.38604 1.06449 4.88338 1.00673L5 1H19C19.5523 1 20 1.44772 20 2C20 2.51284 19.614 2.93551 19.1166 2.99327L19 3H17.999L18 6C18 8.39746 16.6033 10.7256 14.8127 12.0004C16.6033 13.2744 18 15.6025 18 18L17.999 21H19C19.5523 21 20 21.4477 20 22C20 22.5128 19.614 22.9355 19.1166 22.9933L19 23L7 23L5 23ZM11.999 13C10.2609 12.9982 8 15.4858 8 18L7.999 21H15.999L16 18C16 15.4858 13.7391 12.9982 12.001 13L11.999 13ZM15.999 3H7.999L8 6C8 8.51034 10.254 10.9942 11.991 11L12.001 11C13.6894 11.0017 15.8712 8.65429 15.9945 6.21538L16 6L15.999 3Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconHourglass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconHourglass.ce364b6bc532d79c2ac5cc2cf9d5d1e3.svg";